module.exports = __webpack_public_path__ + "img/slide2.15678347.png";